<script setup>

import AuthLayout from "../../login/components/view-components/AuthLayout.vue";
</script>

<template>
    <AuthLayout show-legal>
        <p class="text-3xl">Ale ne...</p>
        <p>Omlouváme se, ale v tuto chvíli je formulář nedostupný, na opravě tvrdě pracujeme. Zkuste to znovu za chvíli.</p>
    </AuthLayout>
</template>

<style scoped lang="scss">

</style>
